var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.668,
    viewBox: "0 0 20 17.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_22",
    "data-name": "Union 22",
    d: "M.772,16.9A2.637,2.637,0,0,1,0,15.031V2.637A2.637,2.637,0,0,1,2.637,0h6.8a2.637,2.637,0,0,1,2.637,2.637V5.274a1.055,1.055,0,1,1-2.11,0V2.637a.527.527,0,0,0-.527-.527h-6.8a.527.527,0,0,0-.527.527V15.031a.527.527,0,0,0,.527.527h6.8a.528.528,0,0,0,.527-.527V12.658a1.055,1.055,0,0,1,2.11,0v2.373a2.637,2.637,0,0,1-2.637,2.637h-6.8A2.637,2.637,0,0,1,.772,16.9ZM14.63,14.267A1.055,1.055,0,0,1,13.9,12.46l2.473-2.439H6.147a1.055,1.055,0,0,1,0-2.11H16.368L13.894,5.472a1.055,1.055,0,0,1,1.482-1.5l4.309,4.246a1.055,1.055,0,0,1,0,1.5l-4.306,4.246a1.055,1.055,0,0,1-.741.3Z",
    fill: "#002a57",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.1034f69741dfde0c10e749143a60b6d1.svg";
export { ForwardRef as ReactComponent };